import {
  EditorColorScheme,
  PortalBgType,
  PortalBorderType,
  PortalShadowType,
  PortalTextType,
  PortalThemeColors,
  TailwindCommonPalette,
  TailwindExtraPalette,
} from '@nx-frontend/shared/types';

export const ThemeTheSpaceGray: PortalThemeColors = {
  key: 'space_gray',
  iconSet: 'default',
  name: 'The Space Gray',
  thumbnail: '/assets/img/themes/space-gray/space-gray.png',
  preview: '/assets/img/themes/space-gray/space-gray-preview-full.png',
  description: 'Modern gray tones and gradients, minimalist design',
  icon: '/assets/img/icon-light.svg',
  logo: '/assets/img/k-logo-light.svg',
  editorColor: EditorColorScheme.LIGHT,
  [PortalBgType.PRIMARY]: [TailwindCommonPalette.ZINC_700],
  [PortalBgType.SECONDARY]: [TailwindCommonPalette.ZINC_700],
  [PortalBgType.HEADER]: [TailwindCommonPalette.TRANSPARENT],
  [PortalBgType.HEADER_MENU]: [TailwindCommonPalette.TRANSPARENT],
  [PortalBgType.BODY]: [TailwindCommonPalette.WHITE, TailwindCommonPalette.NEUTRAL_400, ['bg-gradient-to-b']],
  [PortalBgType.FOOTER]: [TailwindCommonPalette.WHITE],
  [PortalBgType.SURFACE]: [TailwindCommonPalette.WHITE],
  [PortalBgType.SURFACE_DISABLE]: [TailwindCommonPalette.ZINC_50],
  [PortalBorderType.SURFACE_DISABLE]: [TailwindCommonPalette.ZINC_400],
  [PortalTextType.SURFACE_DISABLE]: [TailwindCommonPalette.ZINC_400],
  [PortalBgType.SURFACE_TEXT]: [TailwindCommonPalette.BLACK],
  [PortalBgType.SURFACE_VARIANT]: [TailwindCommonPalette.WHITE],
  [PortalBgType.SURFACE_INNER]: [TailwindCommonPalette.WHITE],
  [PortalBgType.SURFACE_INNER_VARIANT]: [TailwindCommonPalette.ZINC_100],
  [PortalBgType.SURFACE_INNER_VARIANT_2]: [TailwindCommonPalette.ZINC_100],
  [PortalBgType.SURFACE_INNER_VARIANT_HOVER_2]: [TailwindCommonPalette.ZINC_200],
  [PortalBorderType.SURFACE]: [TailwindCommonPalette.ZINC_200],
  [PortalBorderType.SURFACE_VARIANT]: [TailwindCommonPalette.ZINC_200],
  [PortalBorderType.SURFACE_INNER]: [TailwindCommonPalette.ZINC_200],
  [PortalBorderType.SURFACE_INNER_VARIANT]: [TailwindCommonPalette.ZINC_200],
  [PortalBorderType.FOOTER]: [TailwindCommonPalette.ZINC_700],
  [PortalShadowType.MAIN]: [TailwindCommonPalette.TRANSPARENT],
  [PortalShadowType.HOVER]: [TailwindExtraPalette.ZINC_400_50],
  [PortalShadowType.SEARCH]: [TailwindCommonPalette.TRANSPARENT],
  [PortalBgType.HEADER_HOVER]: [TailwindCommonPalette.ZINC_200],
  [PortalBgType.BODY_HOVER]: [TailwindCommonPalette.ZINC_200],
  [PortalBgType.SURFACE_VARIANT_HOVER]: [TailwindCommonPalette.WHITE],
  [PortalBgType.SURFACE_INNER_HOVER]: [TailwindCommonPalette.ZINC_200],
  [PortalBgType.SURFACE_INNER_HOVER_2]: [TailwindCommonPalette.ZINC_300],
  [PortalBgType.PRIMARY_HOVER]: [TailwindCommonPalette.ZINC_500],
  [PortalBgType.SECONDARY_HOVER]: [TailwindCommonPalette.ZINC_500],
  [PortalBorderType.SURFACE_HOVER]: [TailwindCommonPalette.ZINC_400],
  [PortalBorderType.SURFACE_VARIANT_HOVER]: [TailwindCommonPalette.ZINC_400],
  [PortalBorderType.SURFACE_INNER_HOVER]: [TailwindCommonPalette.ZINC_400],
  [PortalTextType.FOOTER_HOVER]: [TailwindCommonPalette.ZINC_600],
  [PortalTextType.HERO_TEXT]: [TailwindCommonPalette.ZINC_900],
  [PortalBgType.GREETING_1]: [TailwindCommonPalette.ZINC_900],
  [PortalBgType.GREETING_2]: [TailwindCommonPalette.AMBER_400, TailwindCommonPalette.AMBER_600, ['bg-gradient-to-r']],
  [PortalTextType.SURFACE]: [TailwindCommonPalette.ZINC_900],
  [PortalTextType.SURFACE_2]: [TailwindCommonPalette.ZINC_900],
  [PortalTextType.SURFACE_3]: [TailwindCommonPalette.ZINC_500],
  [PortalTextType.SURFACE_VARIANT]: [TailwindCommonPalette.ZINC_900],
  [PortalTextType.SURFACE_VARIANT_2]: [TailwindCommonPalette.ZINC_500],
  [PortalTextType.SURFACE_INNER]: [TailwindCommonPalette.ZINC_900],
  [PortalTextType.SURFACE_INNER_2]: [TailwindCommonPalette.ZINC_500],
  [PortalTextType.SURFACE_INNER_VARIANT]: [TailwindCommonPalette.ZINC_900],
  [PortalTextType.SURFACE_INNER_VARIANT_2]: [TailwindCommonPalette.ZINC_500],
  [PortalTextType.SECONDARY]: [TailwindCommonPalette.WHITE],
  [PortalTextType.HEADER]: [TailwindCommonPalette.ZINC_900],
  [PortalTextType.HEADER_HOVER]: [TailwindCommonPalette.ZINC_900],
  [PortalTextType.BODY]: [TailwindCommonPalette.ZINC_700],
  [PortalTextType.BODY_VARIANT]: [TailwindCommonPalette.ZINC_700],
  [PortalTextType.FOOTER]: [TailwindCommonPalette.ZINC_900],
  [PortalTextType.FOOTER_2]: [TailwindCommonPalette.ZINC_500],
  [PortalTextType.TOOLTIP]: [TailwindCommonPalette.BLACK],
  [PortalBgType.TOOLTIP]: [TailwindCommonPalette.WHITE],
  [PortalTextType.PRIMARY]: [TailwindCommonPalette.ZINC_900],
  [PortalTextType.ON_PRIMARY]: [TailwindCommonPalette.WHITE],
  [PortalTextType.PRIMARY_HOVER]: [TailwindCommonPalette.ZINC_500],
  [PortalBorderType.PRIMARY]: [TailwindCommonPalette.ZINC_700],
  [PortalBorderType.PRIMARY_HOVER]: [TailwindCommonPalette.ZINC_500],
  [PortalBgType.HEADER_LINKS]: [TailwindCommonPalette.TRANSPARENT],
  [PortalBgType.FOOTER_LINE]: [TailwindCommonPalette.ZINC_700],
  [PortalBgType.FOOTER_DIVIDER]: [TailwindCommonPalette.NEUTRAL_300],
  [PortalBgType.FOOTER_LINKS]: [TailwindCommonPalette.ZINC_700],
  [PortalBgType.FILL_SURFACE]: [TailwindCommonPalette.GRAY_500],
  [PortalBgType.FILL_SURFACE_2]: [TailwindCommonPalette.ZINC_900],
  [PortalBgType.FOOTER_LINKS_HOVER]: [TailwindCommonPalette.GRAY_500],
  [PortalBgType.EDIT_BG]: [TailwindCommonPalette.NEUTRAL_800],
  [PortalTextType.EDIT_TEXT]: [TailwindCommonPalette.BLACK],
  [PortalBorderType.EDIT_BORDER]: [TailwindCommonPalette.BLACK],
  [PortalBgType.WARN_SURFACE]: [TailwindCommonPalette.AMBER_50],
};
